module.exports = __webpack_public_path__ + "static/media/Logo.0c233ce3.png";